import { Specialist } from "../types/specialist";
import { get } from "./fetch.core";

async function listSpecialists(type: string) {
  const res = await get<Specialist[]>(`/pos/specialist/list?type=${type}`);
  return res.data;
}

const obj = {
  listSpecialists,
};

export default obj;
